export const environment = {
    production: true,
    brand: 'bmw',
    mock: false,
    assets: {
        cdn: 'https://pro-bmw-group-assets.azureedge.net/v1/bmw',
        imageDir: 'images',
        fontDir: 'fonts'
    },
    timezone: 'DST',
    productsToBeSkipped: ['6 Series'],
    appInsights: {
        instrumentationKey: "1032b385-5f2b-4b8b-9b9c-80ef5bd3a673"
    }
};
